import { ProductNameProp } from './types';

interface SanitizeProductNameProps extends ProductNameProp {
  /**
   * Will replace spaces, hyphens, and underscores with this delimiter.
   * Defaults to underscore.
   */
  delimiter?: string;
}

/**
 * Throws an error if the given product name contains disallowed characters:
 * anything other than alphanumeric, spaces, hyphens, or underscores.
 *
 * @returns sanitized (lowercase and delimiters) product name
 */
export const sanitizeProductName = ({ delimiter = '_', productName }: SanitizeProductNameProps) => {
  // product name should only be alphanumeric and recognized delimiters ('-' '_' and space)
  const alphaAndUnderscoresRegExp = /^[a-zA-Z0-9_\- ]+$/;
  const isValidProductName = alphaAndUnderscoresRegExp.test(productName);
  if (!isValidProductName) {
    throw new Error(
      'Product name can only contain alphanumeric characters, hyphens, spaces, or underscores.',
    );
  }

  const sanitizedProductName = productName
    .toLocaleLowerCase()
    .replace(' ', delimiter)
    .replace('-', delimiter)
    .replace('_', delimiter);

  return sanitizedProductName;
};
